import Icon from "../../assets/logo.png";

function Logo() {
  return (
    <figure>
      <img src={Icon} alt="Logo" />
    </figure>
  );
}

export { Logo };
